import "./PlatformFeatures.css";
import "./theme.css";
import "./SmoothFlow.css";
import useScrollReveal from "./ScrollAnimation";
import { useEffect } from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";

const FeatureCard = ({ item }) => (
  <article className="pf-hex-card">
    <div className="pf-hex-inner">
      <div className="pf-hex-top">
        <span className="pf-number">{item.number}</span>
        <div className="pf-icon">{item.icon}</div>
      </div>
      <div className="pf-hex-content">
        <h3>{item.title}</h3>
        <p>{item.text}</p>
        <a href="/contact-us">
          Explore <span>↗</span>
        </a>
      </div>
    </div>
  </article>
);

export default function PlatformFeatures() {
  useScrollReveal();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const features = [
    {
      number: "01",
      icon: <DescriptionOutlinedIcon />,
      title: "Permit to Work (PTW) Management",
      text: "Digital permit creation, multi-level approvals, and integrated LOTO processes ensure seamless authorization for high-risk activities.",
    },
    {
      number: "02",
      icon: <ReportProblemOutlinedIcon />,
      title: "Incident & Safety Logs",
      text: "Real-time reporting with images, root cause analysis tools, and CAPA workflows for immediate corrective action.",
    },
    {
      number: "03",
      icon: <FactCheckOutlinedIcon />,
      title: "Inspections & Audits",
      text: "Custom checklists, scheduling, scoring, and professional PDF reports for streamlined compliance tracking.",
    },
    {
      number: "04",
      icon: <WarningAmberOutlinedIcon />,
      title: "Emergency Preparedness",
      text: "Plan, execute, and monitor drills with detailed response workflows and escalation mapping.",
    },
    {
      number: "05",
      icon: <SchoolOutlinedIcon />,
      title: "Training & Competency",
      text: "Track inductions, certifications, and skill renewals to maintain workforce readiness.",
    },
    {
      number: "06",
      icon: <AnalyticsOutlinedIcon />,
      title: "EHS Dashboard",
      text: "Monitor live KPIs, compare multi-site performance, and visualize safety metrics instantly.",
    },
  ];

  return (
    <section className="features-section" aria-label="Platform Features">
      <div className="pf-shell">
        <div className="pf-heading">
          <div className="pf-eyebrow">THE PARIVIKSHAK PLATFORM</div>
          <h2>One platform. Multiple possibilities.</h2>
          <p>
            Every safety process connects through one intelligent ecosystem —
            from permits and incidents to workforce readiness and performance.
          </p>
          <div className="pf-heading-line">
            <span />
            <span />
            <span />
          </div>
        </div>

        <div className="pf-network">
          <span className="pf-connector pf-connector-1" />
          <span className="pf-connector pf-connector-2" />
          <span className="pf-connector pf-connector-3" />
          <span className="pf-connector pf-connector-4" />
          <span className="pf-connector pf-connector-5" />
          <span className="pf-connector pf-connector-6" />

          <div className="pf-center">
            <div className="pf-center-ring">
              <div className="pf-center-core">
                <SecurityOutlinedIcon />
                <strong>Parivikshak</strong>
                <span>SAFETY PLATFORM</span>
              </div>
            </div>
          </div>

          <div className="pf-node pf-node-1">
            <FeatureCard item={features[0]} />
          </div>

          <div className="pf-node pf-node-2">
            <FeatureCard item={features[1]} />
          </div>

          <div className="pf-node pf-node-3">
            <FeatureCard item={features[2]} />
          </div>

          <div className="pf-node pf-node-4">
            <FeatureCard item={features[3]} />
          </div>

          <div className="pf-node pf-node-5">
            <FeatureCard item={features[4]} />
          </div>

          <div className="pf-node pf-node-6">
            <FeatureCard item={features[5]} />
          </div>
        </div>
      </div>
    </section>
  );
}
